import { render, staticRenderFns } from "./ShopGroupMultiSelect.vue?vue&type=template&id=587136aa&scoped=true"
import script from "./ShopGroupMultiSelect.vue?vue&type=script&lang=js"
export * from "./ShopGroupMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./ShopGroupMultiSelect.vue?vue&type=style&index=0&id=587136aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587136aa",
  null
  
)

export default component.exports